import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7342bffe"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container long-container",
  id: "compileContent"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "row"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-4 long-left"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-8 long-right"
  }, [/*#__PURE__*/_createElementVNode("h2", null, "公司简介"), /*#__PURE__*/_createElementVNode("h3", null, "COMPANY PROGILE"), /*#__PURE__*/_createElementVNode("p", null, "上海昨非成立于2009年，2009年至2020年期间从事生物实验/检测相关，国内外知名品牌的设备，试剂，耗材的代理和经销业务。"), /*#__PURE__*/_createElementVNode("p", null, "2020年，通过十几年的市场经验累积和资源整合，昨非组建了自己的研发和生产团队，开启了集研发、生产、销售和服务的综合性企业的征程。"), /*#__PURE__*/_createElementVNode("p", null, "目前昨非研发/生产团队共有16 人，其中，有取得2 项日本国专利，有十数年日本汽车制造/技术经验的管理人员；有先后获得29 项专利的高级机械设计工程师；也有取得过8 项专利的软件工程师，同时他还精通生物实验行业翘楚（Tecan，Hamilton 等）产品的构造及实现。多元化的团队汇集各个领域经验，应用到昨非产品的设计和生产中，使昨非产品以优异，突出的设计，稳定高质高效的生产来满足行业和客户的需求。 ")])], -1);
});

var _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}